<template lang="pug">
#v-header.header
  img.header__logo(v-if='!$store.state.mobile', src='@/assets/logo.png', alt='KEYSIGHT', width='188')
  img.header__logo(v-else, src='@/assets/m-logo.png', alt='KEYSIGHT', width='116')
  h1.header__title 5G 商機前哨戰，精準量測掌握未來！
  h2.header__sub
    | 填毫米波量測知識問卷
    span(v-if='!$store.state.mobile') ，
    br(v-else)
    | 抽實用好禮
</template>

<script>
export default {
  name: 'Header',
}
</script>

<style lang="sass" scoped>
.header
  padding-bottom: 135px
  padding-top: 135px
  position: relative
  text-align: center
  &__logo
    position: absolute
    right: 50px
    top: 30px
  &__title
    +font(56px, white, null, 2px, bold)
    margin-bottom: 30px
    &::after
      border-bottom: 2px solid white
      content: ''
      display: block
      margin-left: auto
      margin-right: auto
      padding-bottom: 34px
      width: 80px
  &__sub
    +font(28px, white, null, 3.5px)

@media (max-width: 991px)
  .header
    padding: 30px
    &__logo
      position: static
      margin-bottom: 30px
    &__title
      +font(28px, null, 42px, 1.5px, bold)
      margin-bottom: 24px
      &::after
        padding-bottom: 24px
        width: 55px
    &__sub
      +font(16px, null, 26px, 2px)
</style>
